import { DEFAULT_REGION_ID } from "@/components/Header/Info";
import { fillImages } from "../images";
import client from './client';
import { ISearchPrepResponse, IBlockedObjectResponse, ISearchObjectResponse } from '@/types/api-responses';

export async function searchPreps(search: string, obj_id?: number, synonims: number = 0, regionId: number = DEFAULT_REGION_ID) {
    const { data } = await client.GET('/api/v1/public/search/products', {
        params: {
            query: {
                q: search,
                pharmacyId: obj_id || undefined,
                synonyms: Boolean(synonims),
                region: regionId
            }
        }
    });
    const response = data as unknown as ISearchPrepResponse[];
    if (response) fillImages(response);
    return response;
}

export async function getBlockedObjects(prepId: number, regionId: number = DEFAULT_REGION_ID) {
    const { data } = await client.GET('/api/v1/public/search/pharmacies/blocked', {
        params: { query: { productId: prepId, region: regionId } }
    });
    return data as unknown as IBlockedObjectResponse[];
}

export async function searchProizvPreps(regionId: number = DEFAULT_REGION_ID) {
    const { data } = await client.GET('/api/v1/public/search/products', {
        params: { query: { type: 'proizv', region: regionId } }
    });
    const response = data as unknown as ISearchPrepResponse[];
    if (response) fillImages(response);
    return response;
}

export async function searchCustomPreps(regionId: number = DEFAULT_REGION_ID, type: string) {
    const { data } = await client.GET('/api/v1/public/search/products', {
        params: { query: { type, region: regionId } }
    });
    const response = data as unknown as ISearchPrepResponse[];
    if (response) fillImages(response);
    return response;
}

export async function searchObjects(prepsId: number[], regionId: number = DEFAULT_REGION_ID) {
    const prepsIdString = prepsId.join(',');
    const { data } = await client.GET('/api/v1/public/search/pharmacies', {
        params: { query: { productIds: prepsIdString, region: regionId } }
    });
    const response = data as unknown as ISearchObjectResponse[];
    return Array.isArray(response) ? response : [];
}